import * as React from 'react'

import CardListEmpty from '~/client/src/shared/components/CardList/CardListEmpty'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import { useResourcePickerContext } from '../ResourcePickerContext'

interface IProps {
  message?: string
}

const PickerEmptyState: React.FC<IProps> = ({ message }) => {
  const { filteredRecords, loading } = useResourcePickerContext()

  if (loading || filteredRecords.length > 0) {
    return null
  }

  return (
    <CardListEmpty
      message={message ?? Localization.translator.noDataAvailable}
    />
  )
}

export default PickerEmptyState
